import React, { createContext, useContext, useCallback } from "react";
import useTrackDocDownloadSF from "../../investWithUs/hooks/useTrackDocDownloadSF";
import useGetDownloadDocUrl from "./useGetDownloadDocUrl";
import { useUpsellWidgetModel } from "./useUpsellWidgetModelContext";

const RedirectContext = createContext();

export const UpsellWidgetRedirectProvider = ({ children }) => {
    const getDownloadDocUrl = useGetDownloadDocUrl();
    const trackDocDownload = useTrackDocDownloadSF();
    const model = useUpsellWidgetModel();
    const handleRedirect = (loginResponse) => {
        if (model.bookTicketsAfterSignup) {
            //bookTickets();
        }
        const returnUrl = model.returnUrl ?? '';
        const currentUrl = window.location.href;
        if (model.downloadFileId) {
            trackDocDownload(model.downloadFileId);
            window.open(getDownloadDocUrl(model.downloadFileId, model.downloadFileUrl), "_blank");
        }

        const msg = model.displayLoginMessage ? `Welcome back, ${loginResponse.FirstName}` : '';
        redirectToUrl(msg, returnUrl || currentUrl);
    }
    const redirectToUrl = useCallback((message, targetUrl, delay = 0) => {
        const performRedirect = () => {
            const determineUrl = () => {
                // Logic to determine URL if targetUrl is not provided
                const activeTab = document
                    .querySelector('[role=tabpanel].tab-panel li.active a[data-intended-tab]')
                    ?.getAttribute("data-intended-tab");
                if (activeTab) {
                    return updateQueryString("tab", activeTab, window.location.href);
                }
                return ""; // Default to an empty string
            };
            const url = targetUrl || determineUrl();

            const returnForm = $('form[name="returnForm"]');
            if (returnForm) {
                returnForm.find('input[name="url"]').val(url);
                returnForm.find('input[name="message"]').val(message);
                returnForm.find('input[name="overrideCache"]').val('true');
                returnForm.trigger('submit');
            }
        }
        if (delay > 0) {
            setTimeout(performRedirect, delay);
        } else {
            performRedirect();
        }
    }, []);

    return (
        <RedirectContext.Provider value={{
            handleRedirect,
            redirectToUrl
        }}>
            {children}
        </RedirectContext.Provider>
    );
};

export const useUpsellWidgetRedirect = () => {
    const context = useContext(RedirectContext);
    if (!context) {
        throw new Error("useRedirect must be used within a RedirectProvider");
    }
    return context;
};
